/**
 * This is the changeforgottenpassword controller.
 * @memberOf changeforgottenpassword Module
 * @namespace changeforgottenpassword Controller
 */

/**
 * @name changeforgottenpasswordController
 * @desc Create the controller.
 * @param coreService
 * @memberOf changeforgottenpassword Module.changeforgottenpassword Controller
 * @ngInject
 */
function changeforgottenpasswordController($translate, coreService, $window, $log, useEmailLogin) {
    // Assign this controller as the view-model.
    var vm = this;
  
   // Assign this controller as the view-model.
   var minPattern;
   var lowercasePattern = new RegExp("[a-z]+");
   var uppercasePattern = new RegExp("[A-Z]+");
   var numericPattern = new RegExp("[0-9]+");
   var specialCharacterPattern = new RegExp("[\!\"\#\$\%\&\'\(\)\*\+\,\-\.\/\:\;\<\=\>\?\@@\^\_\`\{\|\}\~\]+");
   vm.newPasswordBlur = newPasswordBlur;
   vm.usernameBlur = usernameBlur;
   vm.validateRules = validateRules;
   vm.confirmPasswordBlur = confirmPasswordBlur;
   vm.hasRegExError = false;
   vm.hasConfirmPasswordError = false;
   vm.showEmail = useEmailLogin;
   vm.tempNewPasswordValue = '';

   // Activate the controller.
   activate();

   // Activates the controller.
   function activate() {
       
    // Read Identity Server's data model
    var model = coreService.getIdentityModel();
    vm.model = model;

    vm.hasEmailError = model.hasEmailErrors;
    vm.hasUsernameError = model.hasUsernameErrors;
    vm.submitActionUrl = "/selfservice/login/forgotpassword/change?token=" + vm.model.token;

    // Change display language
    if (model && model.ui_locales) {
      $translate.preferredLanguage(model.ui_locales);
    }

    $translate(['changeforgottenpassword.form.title', 'changeforgottenpassword.form.instruction', 'changeforgottenpassword.form.validaterule_instruction', 
     'changeforgottenpassword.form.validaterule_has_lower_case', 'changeforgottenpassword.form.validaterule_has_upper_case', 'changeforgottenpassword.form.validaterule_has_min_length', 
     'changeforgottenpassword.form.validaterule_has_numeric', 
     'changeforgottenpassword.form.validaterule_has_special_characters', 'changeforgottenpassword.messages.validate_error_invalid_confirm_password',
     'changeforgottenpassword.messages.validate_error_lower_case', 'changeforgottenpassword.messages.validate_error_upper_case',
        'changeforgottenpassword.messages.validate_error_special_char', 'changeforgottenpassword.messages.validate_error_numeric'
        , 'changeforgottenpassword.messages.validate_error_min_char']) 
      .then(function(data) {
            vm.data = data;   
             vm.data['changeforgottenpassword.form.validaterule_has_min_length'] = vm.data['changeforgottenpassword.form.validaterule_has_min_length'].replace('[min_char]', vm.model.minLength);
             vm.data['changeforgottenpassword.messages.validate_error_min_char'] = vm.data['changeforgottenpassword.messages.validate_error_min_char'].replace('[min_char]', vm.model.minLength);        
             var minPatternStr= '^.{'+vm.model.minLength +',}$';
             minPattern = new RegExp(minPatternStr);
            
            if(model.hasErrors){
                setNewPasswordAriaLabelOnLoad(vm.model.enableAriaLabel);
                setFocus("new_password");
            }
            else{
                 setUsernameAriaLabelOnLoad(vm.model.enableAriaLabel, vm.showEmail);
                 setFocusOnLoadUsernameOrEmail(vm.showEmail);
            }
    });     
   };
 
   function validateRegEx(pattern, val)
   {
      return pattern.test(val);
   };
   
   function setVisibility(result, element)
   {
       if (result)
       {
        element.classList.add("glyphicon-one-fine-ok");
        element.classList.remove("glyphicon-one-fine-dot");
       }
       else
       {
        element.classList.add("glyphicon-one-fine-dot");
        element.classList.remove("glyphicon-one-fine-ok");
       }
   };
   
   function setNewPasswordAriaLabelOnLoad(enable){
    var element = document.getElementById('new_password');
    if(enable){
        var arialDescriptionText = vm.data['changeforgottenpassword.form.instruction'];
        if (vm.model.hasMinLength)
        {
            arialDescriptionText = arialDescriptionText + vm.data['changeforgottenpassword.form.validaterule_has_min_length']  + ". ";
        }
        if (vm.model.hasLowerCase)
        {
            arialDescriptionText = arialDescriptionText + vm.data['changeforgottenpassword.form.validaterule_has_lower_case'] + ". ";
        }
        if (vm.model.hasUpperCase)
        {
            arialDescriptionText = arialDescriptionText + vm.data['changeforgottenpassword.form.validaterule_has_upper_case']  + ". ";
        }
        if (vm.model.hasNumeric)
        {
            arialDescriptionText = arialDescriptionText + vm.data['changeforgottenpassword.form.validaterule_has_numeric'] + ". ";
        }
        if (vm.model.hasSpecialCharacters)
        {
            arialDescriptionText = arialDescriptionText + vm.data['changeforgottenpassword.form.validaterule_has_special_characters']  + ". ";
        }

        element.setAttribute('aria-label', arialDescriptionText);
    }
    else{
        element.setAttribute('aria-label', '');
    }
   };

   function setUsernameAriaLabelOnLoad(enable, isEmailAddressVisible)
   {
       var element = isEmailAddressVisible ? document.getElementById('emailAddress') : document.getElementById('username');
       if (enable)
       {
            var arialDescriptionText = vm.data['changeforgottenpassword.form.title'] + ". ";
            element.setAttribute('aria-label', arialDescriptionText);
       }
       else
       {
            element.setAttribute('aria-label', '');
       }
   };

   function usernameBlur(){
        vm.hasUsernameError = false;
        vm.hasEmailError = false;
        vm.model.hasUsernameError = false;
        setUsernameAriaLabelOnLoad(false);
   };

   function newPasswordBlur() {
       vm.hasRegExError = false;
       vm.model.hasErrors = false;
       var val = $window.document.getElementById('new_password').value;
       setNewPasswordAriaLabelOnLoad(false);

       // Clear confirm password if user modified the new password
       if (val !== vm.tempNewPasswordValue) {
            $window.document.getElementById("confirm_password").value = "";
                vm.tempNewPasswordValue = $window.document.getElementById("new_password").value;
       }

       if (val !== "")
       {
           displayRegExErrors(val);
       } 
   };

   function validateRules() {
       var val = $window.document.getElementById('new_password').value;
       setVisibility(validateRegEx(minPattern, val),  $window.document.getElementById('imgMinLength'));
       setVisibility(validateRegEx(lowercasePattern, val), $window.document.getElementById('imgLowerCase'));
       setVisibility(validateRegEx(uppercasePattern, val), $window.document.getElementById('imgUpperCase'));
       setVisibility(validateRegEx(numericPattern, val), $window.document.getElementById('imgNumeric'));
       setVisibility(validateRegEx(specialCharacterPattern, val), $window.document.getElementById('imgSpecialChar'));
   };


   function displayRegExErrors(val)
   {
       $window.document.getElementById("confirm_password").value = "";

       var hasRegExRuleErrors = $window.document.getElementById('regExRuleErrors');
       hasRegExRuleErrors.innerHTML = '';

       var serverSideError = $window.document.getElementById('serverSideError');
       serverSideError.innerHTML = '';

       var error = hasRegExRuleErrors.innerHTML;  

       if (!validateRegEx(minPattern, val) && vm.model.hasMinLength)
       {           
           error =  error + '<span class="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span> <span>'+ vm.data['changeforgottenpassword.messages.validate_error_min_char'] +'</span><br/>';
           vm.hasRegExError = true;
       }

       if (!validateRegEx(lowercasePattern, val) && vm.model.hasLowerCase)
       {    
           error =  error + '<span class="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span> <span>'+ vm.data['changeforgottenpassword.messages.validate_error_lower_case']  +'</span><br/>';
           vm.hasRegExError = true;
       }

       if (!validateRegEx(uppercasePattern, val) && vm.model.hasUpperCase)
       {
           error =  error + '<span class="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span> <span>'+ vm.data['changeforgottenpassword.messages.validate_error_upper_case']  +'</span><br/>';
           vm.hasRegExError = true;
       }

       if (!validateRegEx(numericPattern, val) && vm.model.hasNumeric)
       {
           error = error + '<span class="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span> <span>'+ vm.data['changeforgottenpassword.messages.validate_error_numeric'] +'</span><br/>';
           vm.hasRegExError = true;
       }

       if (!validateRegEx(specialCharacterPattern, val) && vm.model.hasSpecialCharacters)
       {
           error = error + '<span class="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span> <span>'+ vm.data['changeforgottenpassword.messages.validate_error_special_char']  +'</span>';
           vm.hasRegExError = true;
       }

       if (vm.hasRegExError)
       { 
           hasRegExRuleErrors.setAttribute('name', 'passwordConfirm_' + new Date().getTime());
           hasRegExRuleErrors.innerHTML = error;
           setFocus("new_password");
       }
   };

   function confirmPasswordBlur()
   {
        vm.hasConfirmPasswordError = false;
        var confirmValue = $window.document.getElementById('confirm_password').value;
        var newPasswordValue = $window.document.getElementById('new_password').value;
        
        var confirmPasswordErr = $window.document.getElementById('passwordConfirmError');
        if (confirmValue !== '' && confirmValue !== newPasswordValue)
        {
            vm.hasConfirmPasswordError = true;
            confirmPasswordErr.setAttribute('name', 'passwordConfirm_'+ new Date().getTime());
            confirmPasswordErr.innerHTML = vm.data['changeforgottenpassword.messages.validate_error_invalid_confirm_password'];

            var regExRuleErrors = $window.document.getElementById('regExRuleErrors');
            regExRuleErrors.innerHTML = '';

            var serverSideError = $window.document.getElementById('serverSideError');
            serverSideError.innerHTML = '';
            setFocus("confirm_password");
        }
        else
        {
            confirmPasswordErr.innerHTML = '';
        }
    };

    function setFocusOnLoadUsernameOrEmail(isEmailAddressVisible){
        // Set focus on email address if email address is visible and username has no error
        var elementId = isEmailAddressVisible && !vm.hasUsernameError ? 'emailAddress' : 'username';
        setFocus(elementId);
    }

    function setFocus(elementId) {
        // Handle onblur and focus issue on firefox
        setTimeout(function () { 
            $window.document.getElementById(elementId).focus()
        }, 0);
    };
  
}

export default changeforgottenpasswordController;



// WEBPACK FOOTER //
// ./src/login/changeforgottenpassword/changeforgottenpassword.controller.js